import { css } from "@emotion/react";
import { Theme } from "@mui/material";

import { sharedStyles } from "../shared.styles";

export const menuSectionNodeStyles = {
  summaryTextStyles: (theme: Theme) =>
    css({
      color: theme.palette.text.secondary,
      padding: "0 16px 4px 16px",
    }),
  header: css({
    padding: "8px 16px",
    marginBottom: 0,
  }),
  headerPadding: css({
    padding: "16px 16px 8px",
    marginBottom: 0,
  }),
  sectionNodeHeader: (theme: Theme) =>
    css({
      h2: [
        sharedStyles.headerText(theme),
        css({
          alignSelf: "center",
          display: "inline-flex",
        }),
      ],
      height: 48,
    }),
};
